import { combineReducers } from 'redux';

import { IFSAAction } from '../../../store/models';
import { ETextColor } from '../../Projects/enums';
import { ELayoutActions } from './enums';
import { IFooterState, IHeaderState, ILayoutState } from './models';

const setFooterVisibility = (
    state: boolean = true,
    action: IFSAAction<boolean>
): boolean => {
    return action.type === ELayoutActions.SET_FOOTER_VISIBILITY ? action.payload : state;
};

const textColorReducer = (
    state: ETextColor | null = ETextColor.BLACK,
    action: IFSAAction<ETextColor | null>
): ETextColor | null => {
    return action.type === ELayoutActions.SET_HEADER_COLOR ? action.payload : state;
};

export const LayoutReducers = combineReducers<ILayoutState>({
    foooter: combineReducers<IFooterState>({
        isVisible: setFooterVisibility,
    }),
    header: combineReducers<IHeaderState>({
        slider_text_color: textColorReducer,
    }),
});
